module.exports = __webpack_public_path__ + "static/leaf1-01-af27177df316579479414fbc17666c53.png";